import React from 'react';
import styled from 'styled-components';
import {FormControlStructure} from '../../FormControlStructure';
import {conditionDisable} from '../../../form-conditions/conditionDisable';
import {rawSelectStyling} from '../../../form-mixin/rawSelectStyling';
import {formElementSetup} from '../../../form-mixin/formElementSetup';
import {IconFormSelect} from '../../../form-features/IconFormSelect';
import {innerContainerPrefix} from '../../../form-conditions/conditionPrefix';

const Wrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const SelectStructure = ({name, disabled, label, prefix, children, errorMessage}) => (
    <FormControlStructure label={label} name={name} prefix={prefix} disabled={disabled} errorMessage={errorMessage}>
        <Wrapper>
            <SelectWrapper disabled={disabled} prefix={prefix}>
                {children}
            </SelectWrapper>
            <IconFormSelect icon="KeyboardArrowDown" />
        </Wrapper>
    </FormControlStructure>
);

export const SelectWrapper = styled.div`
    background: var(--form-control-background-color);
    border: 1px solid var(--form-control-border-color);
    ${formElementSetup}
    ${rawSelectStyling()};
    ${({prefix}) => innerContainerPrefix(prefix)};
    ${({disabled}) => conditionDisable(disabled)};
`;
